import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';

import { Col } from '../../../components/Col';
import { Container } from '../../../components/Container';
import { CustomButton } from '../../../components/CustomButton';
import RefreshIcon from '../../../components/Icons/RefreshIcon';
import { Row } from '../../../components/Row';
import TextEditor, {
  TEXT_EDITOR_TD_STYLE,
} from '../../../components/TextEditor/TextEditor';
import UnauthorizedScreen from '../../../components/UnauthorizedScreen/UnauthorizedScreen';
import { templatesContratoRoute } from '../../../library/Routes';
import {
  loadMacrosPorTemplate,
  loadTemplateById,
  saveTemplate,
} from '../../../store/modules/ContratosActions';
import { isAuthorizedRequest } from '../../../utils/httpResponseHandlers';
import {
  getElementID,
  getHTMLWithStyleInlineForQuerySelector,
  getMergedClassNames,
} from '../../../utils/HTMLUtils';
import infoIcon from './../../../assets/images/svg/info-black-icon.svg';
import styles from './Template.scss';

const rootElementId = 'contratos-template';

const rootClassName = styles.rootClassName;

class Template extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorizedRequest: true,
      loading: true,
      html: null,
    };
  }

  changeLoadingStatus = (isLoading, moreProps = {}) => {
    if (isLoading !== this.state.loading) {
      this.setState({
        ...this.state,
        loading: isLoading,
        ...moreProps,
      });
    }
  };

  loadMacros = () => {
    this.props.loadMacrosPorTemplate(
      this.props.match.params.id,
      () => {
        this.changeLoadingStatus(false, {
          html: this.props.contratos.editingTemplate.htmlTemplate,
        });
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeLoadingStatus(false);
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorLoadingMacrosPorTemplateContratos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeLoadingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  };

  loadTemplate = () => {
    this.props.loadTemplateById(
      this.props.match.params.id,
      () => {
        this.loadMacros();
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeLoadingStatus(false);
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorLoadingTemplateContratos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeLoadingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  };

  UNSAFE_componentWillMount() {
    this.loadTemplate();
  }

  isLoaded = () => {
    return typeof this.state.html === 'string' ? true : false;
  };

  getMacros = () => {
    let macros = {};
    this.props.contratos.templateMacros.map((macro) => {
      macros[macro.macro.split('#').join('')] = macro.nome;
      return macro.macro;
    });
    return macros;
  };

  toCancel = () => {
    this.props.history.push(templatesContratoRoute.path);
  };

  toSubmit = (html) => {
    this.changeLoadingStatus(true);
    this.props.saveTemplate(
      {
        id: this.props.match.params.id,
        htmlTemplate: getHTMLWithStyleInlineForQuerySelector(html, [
          {
            querySelector: 'td',
            style: TEXT_EDITOR_TD_STYLE,
          },
        ]),
      },
      () => {
        this.props.history.push(templatesContratoRoute.path);
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeLoadingStatus(false);
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorSavingTemplateContratos,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeLoadingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  };

  getLoadingIcon = () => {
    if (!this.state.loading) {
      return '';
    }
    return (
      <RefreshIcon
        className={getMergedClassNames([rootClassName + '-loading-icon'])}
      />
    );
  };

  onChange = (value) => {
    this.setState({
      html: value,
    });
  };

  render() {
    return this.state.authorizedRequest &&
      this.props.auth.userPermissions.contratos.assessor.templates.edit ? (
      <Container className={rootClassName + '-container container-fluid'}>
        <div className={rootClassName + '-content container-fluid'}>
          <TextEditor
            className={rootClassName + '-editor'}
            disabled={this.state.loading || !this.isLoaded()}
            value={this.isLoaded() ? this.state.html : ''}
            onChange={(html) => {
              this.setState({
                html,
              });
            }}
            beforeCustomButtons={[
              {
                iconURL: infoIcon,
                tooltip: 'Macros',
                exec: (editor, control, btn) => {
                  editor.selection.insertHTML('#' + btn.args[0] + '#');
                },
                list: this.getMacros(),
              },
            ]}
            actionButtons={(html) => (
              <Row className={rootClassName + '-row-buttons'}>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomButton
                    id={getElementID(rootElementId + 'cancel')}
                    theme='pufvYellow'
                    className={rootClassName + '-cancel-button'}
                    label='Cancelar'
                    onClick={this.toCancel}
                    disabled={this.state.loading}
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomButton
                    id={getElementID(rootElementId + 'save')}
                    theme='pufvYellow'
                    className={rootClassName + '-save-button'}
                    label='Salvar'
                    onClick={() => this.toSubmit(html)}
                    disabled={this.state.loading}
                  />
                </Col>
              </Row>
            )}
          />
          {this.getLoadingIcon()}
        </div>
      </Container>
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadTemplateById,
      loadMacrosPorTemplate,
      saveTemplate,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Template));
